import React from "react";
import { string } from "prop-types";
import LocalNavigationBar from "../../molecules/LocalNavigationBar";
import ContentParagraph from "../../molecules/ContentParagraph";

import "./events-content-section.m.css";

const EventsContentSection = ({ content, ...props }) => {
  return (
    <section styleName="events-content-section" {...props}>
      <LocalNavigationBar />
      <ContentParagraph content={content} />
    </section>
  );
};

EventsContentSection.propTypes = {
  content: string
};

export default EventsContentSection;